import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}function n(e,t){let n={};for(let[r,i]of Object.entries(e)){let a=t(i,r,e);n[r]=a}return n}export{t as mapValues};
//# sourceMappingURL=mapValues-d3nyFxBh.js.map